export const PRODUCT_PAGE_URL =
  // 'https://crafty-speaker-4317.ck.page/products/book';
  'http://gum.co/cutintothejamstack';
export const HOME_SECTION_V_PADDING = 10;

export const SITE_NAME = 'Cut Into The Jamstack';
